import React from "react";
import FilterContainer, {CoreFiltersBaseProps} from "../../../../../../components/FilterContainer";
import {Form, Input} from "antd";

export default function SystemBuildingsScreenFilter({filter, onSubmit}: CoreFiltersBaseProps) {
  return (
    <FilterContainer
      onResetFilters={filter.resetFilters}
      onSubmit={onSubmit}
      isSubmitting={undefined}
    >
      <Form layout='vertical'>
        <Form.Item label='Name'>
          <Input
            allowClear
            value={filter.getFilter('name')}
            onChange={e => filter.setFilter('name', e.target.value)}
          />
        </Form.Item>
      </Form>
    </FilterContainer>
  )
}
